exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "factura-form .row>h4{margin-bottom:20px;margin-top:20px}factura-form .table>tbody>tr>td{vertical-align:middle}.mbottom-20{margin-bottom:20px}.mtop-20{margin-top:20px}.especialista-factura small{display:block}.ui-select-match .select-detalles{display:none}.add-descuento-forma-pago-btn{display:block;margin-bottom:16px}.badge-no-timbrados{margin-left:4px}.btn-descuento{height:40px;align-items:center;display:inline-flex;justify-content:center;padding:18px;font-size:14px}.td-centered{text-align:center!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/facturas/form/form.scss
// module id = 1644
// module chunks = 0